import {routes} from "@project/router";
import {createFileRoute, redirect} from "@tanstack/react-router";

/**
 * Root path redirect route (/).
 *
 * This route handles requests to the root path and redirects them to /dashboard.
 * Using file-based routing convention: the filename/path structure mirrors the URL structure.
 *
 * The `beforeLoad` hook fires before any component renders, making it ideal for redirects.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({to: routes.dashboard()});
  },
});
